// extracted by mini-css-extract-plugin
export default {"registerForm":"registerForm_registerForm__440ah","error":"registerForm_error__iTt8u","success":"registerForm_success__3CNF4","agreedLink":"registerForm_agreedLink__nS9Xq"};